import { render, staticRenderFns } from "./LogoSignatureAlignedLeftSection.vue?vue&type=template&id=47e8a7d0"
import script from "./LogoSignatureAlignedLeftSection.vue?vue&type=script&lang=ts"
export * from "./LogoSignatureAlignedLeftSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoSignatureAlignedLeftSection.vue?vue&type=style&index=0&id=47e8a7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports